import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import isToday from '@sdk/utils/dateUtils/isToday';

type Props = {
  date: string;
};

const TextFirstLine = ({ date }: Props) => {
  return (
    <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
      {isToday(date)
        ? gettext('No employees scheduled today.')
        : gettext('No employees scheduled this day.')}
    </Text14>
  );
};

export default TextFirstLine;
